<loading-indicator [show]="displayLoader"></loading-indicator>
